import { createRepository } from './Repository'

export interface ReferralResponse {
  referral_link: string;
  referral_count: number;
  total_spent: number;
  bill_count: number;
  total_earned: number;
  balance: number;
  referral_percent: number;
  free_days_for_referral: number;
}

const repository = createRepository({
  basePath: '/api',
  useAuth: true
})

export const ReferralRepository = {
  getRefSystem: () => {
    return repository.get<ReferralResponse>('/refSystem')
  }
}
